import wx from 'weixin-js-sdk';
export const fshare = function (sharetitle,shareimg,sharedesc,sharelink){
	// console.log(sharetitle)
	// console.log(shareimg)
	// console.log(sharelink)
	// console.log(sharedesc)
    
	wx.ready(function () {
		wx.onMenuShareTimeline({ // “分享到朋友圈”及“分享到QQ空间”
			title: sharetitle,
			link: sharelink,
			imgUrl: shareimg,
			success: function () {
			},
		})
		wx.onMenuShareAppMessage({ // “分享给朋友”及“分享到QQ”
			title:sharetitle,
			desc:sharedesc,
			link: sharelink,
			imgUrl: shareimg,
			success: function () {
			},
		})
	})
}